export enum FamilyMemberType {
  PARENT = 'PARENT',
  VIEWER = 'VIEWER',
  CHILD = 'CHILD',
  MODERATOR = 'MODERATOR',
  DELETED = 'DELETED',
  EXPERT = 'EXPERT',
}

export enum FamilyMemberSex {
  MAN = 'MAN',
  WOMAN = 'WOMAN',
  OTHER = 'OTHER',
  UNKNOWN ="UNKNOWN"
}


// WEBPACK FOOTER //
// ./src/services/family/family.constants.ts